<template>
  <div class="transaction-checks-component d-flex align-center">
    <div class="checks-amount d-flex align-center justify-center">
      <span class="text-sm-h3 font-weight-medium">{{ checks }} ч.</span>
    </div>
    <div class="d-flex flex-column">
      <span class="label">Количество чеков:</span>
      <v-slider
        v-model="checks"
        hide-details
        min="0"
        :max="checksQuantity"
        color="#ff9100"
        thumb-color="#ff9100"
        track-color="#ff9100"
        track-fill-color="red"
        :disabled="!checksQuantity"
      ></v-slider>
    </div>
    <!--    <v-btn @click="increaseChecks" class="button-primary mr-3" height="60px">-->
    <!--      <font-awesome-icon icon="arrow-up" />-->
    <!--    </v-btn>-->
    <!--    <v-btn @click="decreaseChecks" class="button-primary" height="60px">-->
    <!--      <font-awesome-icon icon="arrow-down" />-->
    <!--    </v-btn>-->
  </div>
</template>

<script>
  export default {
    name: 'TransactionChecks',
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: {
        type: Number,
        default: 0,
      },
      transaction: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      checks: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
      checksQuantity () {
        try {
          return this.transaction.senderBalance.terminalChecksQuantity || 0
        } catch {
          return 0
        }
      },
    },
    methods: {
      increaseChecks () {
        if (this.transaction && this.transaction.senderBalance) {
          const checksQuantity = this.transaction.senderBalance.terminalChecksQuantity || 0
          if (checksQuantity && this.checks < checksQuantity) {
            this.checks++
          }
        }
      },
      decreaseChecks () {
        if (!this.checks) return
        this.checks--
      },
    },
  }
</script>

<style lang="less" scoped>
  .transaction-checks-component {
    margin-bottom: 16px;

    .checks-amount {
      height: 80px;
      padding: 0 10px;
      min-width: 226px;
      border-radius: 10px;
      border: 1px solid @color-primary;
      margin-right: 16px;
    }

    .label {
      font-size: 20px;
    }
  }
</style>
